'use strict';

var headerUtils = require('core/utilities/headerUtils');

var updateHeader = status => {
    var $headerNav = $('.header-nav');
    var $mainMenu = $('.main-menu');
    var $modalBackground = $('.modal-background');
    var headerNavHeight = headerUtils.getHeaderHeightNavOnly();
    var $page = $('.page');

    if (status === 'fixed') {
        $headerNav.addClass('fixed');

        headerNavHeight = headerUtils.getHeaderHeightNavOnly();

        $modalBackground.css('top', headerNavHeight);
        $mainMenu.css('top', headerNavHeight);

        if (!($headerNav.closest('.transparent-header').length)) {
            $page.css('margin-top', headerNavHeight + 'px');
        }
        $headerNav.removeClass('transparent-nav');
    } else {
        $headerNav.removeClass('fixed');
        $page.css('margin-top', '');

        headerNavHeight = headerUtils.getHeaderHeight();

        $modalBackground.css('top', headerNavHeight);
        $mainMenu.css('top', headerNavHeight);

        var isMobileOpen = $('body').hasClass('mobile-menu-in');
        if (!isMobileOpen){
            $headerNav.addClass('transparent-nav');
        }
    }
}

function popupPatronChat() {
    let url = "https://home-c57.nice-incontact.com/inContact/ChatClient/ChatClient.aspx?poc=584d498a-a09d-477a-84cc-9f8fafe1dd14&bu=4604986&P1=First Name&P2=Last Name&P3=first.last@company.com&P4=555-555-5555";
    window.open(url, 'icPatronChatWin', 'location=no,height=630,menubar=no,status-no,width=410', true);
}

module.exports = function() {

    // Fix/unfix header to top of screen, dependent on class added by custom preference
    // Note: This is intentionally not using utilities/scroll.js so that it can fix immediately vs. being debounced. Should be replaced with CSS position:sticky once IE11 support is dropped.
    var hasFixedHeader = $('header').hasClass('fixed-header');
    $(window).scroll(event => {
        if (hasFixedHeader) {
            var preNavHeight = headerUtils.getHeaderHeight('.header-nav');
            var scrollTop = $(event.target).scrollTop();

            if (scrollTop > preNavHeight) {
                updateHeader('fixed');
            } else {
                updateHeader('unfixed');
            }
        }
    });

    var isMobile = window.isMobile();
    if ($('header').hasClass('transparent-header') && !isMobile) {
        $(($('.logo-left').length ? '.header-nav' : '.header-nav:not(.secondary-nav)')).hover(
                function() {
                    $(this).removeClass('transparent-nav').find('.secondary-nav').removeClass('transparent-nav');
                    $(this)[$(this).hasClass('secondary-nav') ? 'prev' : 'next']('.header-nav').removeClass('transparent-nav');
                }, function() {
                    $(this).addClass('transparent-nav').find('.secondary-nav').addClass('transparent-nav');
                    $(this)[$(this).hasClass('secondary-nav') ? 'prev' : 'next']('.header-nav').addClass('transparent-nav');
                }
        );
    }

    // Check for presence of content assets in MegaMenu
    var $megamenuDropdown = $('.megamenu > .dropdown-menu');

    $megamenuDropdown.each((index, element) => {
        var $megamenu = $(element);
        if ($megamenu.find('.megamenu-asset-1').children().length) {
            $megamenu.addClass('has-asset-1');
        }
        if ($megamenu.find('.megamenu-asset-2').children().length) {
            $megamenu.addClass('has-asset-2');
        }
    });

    // Show/hide content assets on mobile based on category level
    if (isMobile) {
        var $thirdMenuBackBtn = $('.megamenu .menu-subcategories > .dropdown-item'),
            $thirdSubLink = $('.megamenu .menu-subcategories > .dropdown-item > .dropdown-link');

        $thirdSubLink.on('click', function () {
            $('.megamenu.show .menu-subcategories').parent('li').addClass('thirdCatOpen');
        });
        $thirdMenuBackBtn.on('click', function () {
            $('.megamenu.show .menu-subcategories').parent('li').removeClass('thirdCatOpen');
        });
    }

    $('.main-menu .navbar-nav').on('mouseenter mouseleave', function () {
        $(this).toggleClass('nav-item-hover');
    });

    $('.main-menu .navbar-nav:not(.secondary-navbar) .nav-item').on('mouseenter mouseleave', function () {
        if ($('#top-header .header-nav.secondary-nav').length && !this.classList.value.includes('inview')) {
            $('#top-header  .header-nav.secondary-nav').toggleClass('show hide-secondary-nav');
        }
    });

    $('header .site-search').on('mouseenter', event => {
        var $siteSearch = $(event.target).closest('.site-search');
        $siteSearch.addClass('expanded');
    });

    $('header .site-search').on('mouseleave', event => {
        var $siteSearch = $(event.target).closest('.site-search');
        var $input = $siteSearch.find('input');
        // Only collapse if the user isn't typing and hasn't entered text
        if (!$input.is(':focus') && !$input.val()) {
            $siteSearch.removeClass('expanded');
        }
    });

    $('form[name=simpleSearch]').on('submit', event => {
        var $form = $(event.target);
        var $input = $('input[name=q]',$form);
        //trim excessive whitespace from query
        if ($input.length) {
            var trimmedValue = $.trim($input.val()).replace(/\s+/g, ' ');
            $input.val(trimmedValue);
        }

        //keep search from submitting if query is empty
        if ($input.val() == "") {
            $input.focus();
            event.preventDefault();
        }
    });

    //targetting chat in the footer
    $('.rcchatcontainer').on('click', function(e){
        e.preventDefault();
        popupPatronChat()
    })

    //targeting chat in the navigation
    $('#nav-head-01-service-chat').on('click', function(e){
        e.preventDefault();
        popupPatronChat();
    })
};
